import InboxDetail from "./InboxDetail";

export default InboxDetail;
